import { render, staticRenderFns } from "./CheckboxColor.vue?vue&type=template&id=071addb7&"
import script from "./CheckboxColor.vue?vue&type=script&lang=js&"
export * from "./CheckboxColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports